// extracted by mini-css-extract-plugin
export default {"tab":"Tab-module__tab__1k7yI","content":"Tab-module__content__ay2UQ"};